import { TDoor } from 'shared/types/doors';
import { DoorContent } from '../DoorContent';

export const ThirdDoorContent: React.FC<TDoor> = props => {
  return (
    <DoorContent btnText="Открыть плейлист" {...props}>
      <div>Мы рады поделиться с вами праздничным настроением — специальным новогодним плейлистом 🎶</div>
      <div>
        В нём — любимые зимние и новогодние треки команды Циан.Посуточно. Этот сборник поможет создать уютную атмосферу
        при общении с гостями, подготовке объектов к праздникам или во время вечернего планирования.
      </div>
      <div>
        Пусть музыка станет приятным фоном для ваших предновогодних хлопот и зарядит вдохновением на успешное завершение
        года и яркий старт 2026-го! 🎄✨
      </div>
    </DoorContent>
  );
};
